var _a;
import { __decorate, __metadata } from "tslib";
import { external, inject, TSDI } from 'tsdi';
let Injector = class Injector {
    // eslint-disable-next-line ml-rules/no-tsdi-decorators
    tsdi;
    get(Dependency) {
        return this.tsdi.get(Dependency);
    }
    getScope(name) {
        return this.tsdi.getScope(name);
    }
};
__decorate([
    inject,
    __metadata("design:type", typeof (_a = typeof TSDI !== "undefined" && TSDI) === "function" ? _a : Object)
], Injector.prototype, "tsdi", void 0);
Injector = __decorate([
    external
], Injector);
class InjectorFactory {
    injector;
    get(Dependency) {
        if (!this.injector) {
            this.injector = new Injector();
        }
        return this.injector.get(Dependency);
    }
    getScope(name) {
        if (!this.injector) {
            this.injector = new Injector();
        }
        return this.injector.getScope(name);
    }
}
export const tsdiInjector = new InjectorFactory();
